import React from 'react';

export const withMemo = <P extends object>(Component: React.FC<P>) => React.memo(Component);
